import React from 'react'
import {
    useDataGrid,
    DataGrid,
    GridColumns,
    Stack,
    EditButton,
    ShowButton,
    List,
    TextFieldComponent,
    Icon,
} from '@pankod/refine-mui'

import { Category } from 'gql/graphql'

const columns: GridColumns<Category> = [
    {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        minWidth: 350,
        renderCell: function render(params) {
            return <TextFieldComponent value={params.row.name.en} />
        },
    },
    {
        field: 'code',
        headerName: 'Code',
        flex: 1,
        minWidth: 350,
        renderCell: function render(params) {
            return <TextFieldComponent value={params.row.code} />
        },
    },
    {
        field: 'icon',
        headerName: 'Icon',
        flex: 1,
        minWidth: 350,
        renderCell: function render(params) {
            return <Icon>{params.row.icon}</Icon>
        },
    },
    {
        field: 'sortIndex',
        headerName: 'Sort Index',
        type: 'number',
        flex: 1,
        minWidth: 350,
        renderCell: function render(params) {
            return <TextFieldComponent value={params.row.sortIndex} />
        },
    },
    {
        field: 'parent',
        headerName: 'Parent',
        flex: 1,
        minWidth: 350,
        renderCell: function render(params) {
            return <TextFieldComponent value={params.row.parent?.name?.en ?? '--'} />
        },
    },
    {
        headerName: 'Actions',
        field: 'actions',
        minWidth: 250,
        renderCell: function render(params) {
            return (
                <Stack direction="row" spacing={1}>
                    <ShowButton hideText recordItemId={params.row.id} />
                    <EditButton hideText recordItemId={params.row.id} />
                </Stack>
            )
        },
    },
]

export const CategoriesList: React.FC = () => {
    const { dataGridProps } = useDataGrid<Category>({
        dataProviderName: 'categories',
        initialSorter: [{ field: 'sortIndex', order: 'asc' }],
    })

    return (
        <List>
            <DataGrid {...dataGridProps} columns={columns} autoHeight />
        </List>
    )
}
